import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Dialog, Transition } from '@headlessui/react'
import agentComponent from '../../businesses/agent';
import VerticalBarChart from '../businessInteligence/VerticalBarChart'
import MultiaxisLineChart from '../businessInteligence/MultiaxisLineChart'
import FullPageLoader from '../Layout/FullPageLoader'
import ProgressBar from '../businessInteligence/ProgressBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';

const PerformanceModal = (props) => {
    const { showModal, setShowModal, year } = props;
    const [agent, setAgent] = useState();
    const [loading, setLoading] = useState(true);
    const [agentPerformance, setAgentPerformance] = useState(null);
    const agentId = useSelector(state => state.viewAgentId);

    useEffect(() => {
        if (agentId) {
            (async () => {
                setAgent(await agentComponent.profile(agentId));
                const agentPerformance = await agentComponent.myPerformance(agentId, year);
    
                if (agentPerformance) 
                    setAgentPerformance(agentPerformance)
                    setLoading(false)
            })();
        }
    }, [agentId,year]);

    return (
        <Transition appear show={ props.showModal } as={ Fragment }>
            <Dialog  as="div" className="relative z-40" onClose={ () => props.setShowModal(false) }>
                <Transition.Child
                    as={ Fragment }
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="h-full md:p-5 p-2">
                        <Transition.Child
                            as={ Fragment }
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full h-full transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all">
                                <div className='w-full h-full flex flex-col'>
                                    <div className='c-w-flex'>
                                        <div className='banner'>
                                            <div className='flex items-center justify-between'>
                                                {`${agent?.UserName}'s Performance in detail ${agentPerformance?.tripAchievement.year}`}

                                                <button onClick={ () => props.setShowModal(false) } className='cursor-pointer px-2 hover:opacity-70 focus-visible:outline-none'>
                                                    <FontAwesomeIcon icon={ faX } className='h-3 w-3' />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="full-rel">
                                        <FullPageLoader loading={loading} />

                                        <div className='full-abs md:p-5 p-3'>
                                            <div className='flex flex-col gap-4'>
                                                <div className="grid md:grid-cols-3 gap-4">
                                                    {
                                                        agentPerformance &&
                                                        Object.entries(agentPerformance.case).map(([key, value], idx) => 
                                                            (
                                                                <div key={'case_' + idx} className='rounded-[10px] bg-white shadow-md p-4'>
                                                                    <p className='font-semibold text-gray-two md:text-sm text-xs capitalize'>Total { key }</p>

                                                                    <div className='mt-2 flex flex-col gap-1'>
                                                                        <div className='flex items-center'>
                                                                            <p className='font-medium text-gray-one md:text-base text-sm'>Completed Case</p>
                                                                            <p className='font-medium text-primary ml-auto md:text-4xl text-2xl'>{ value.completed }</p>
                                                                        </div>

                                                                        <div className='flex items-center'>
                                                                            <p className='font-medium text-gray-one md:text-base text-sm'>Pending Case</p>
                                                                            <p className='font-medium text-orange ml-auto md:text-4xl text-2xl'>{ value.pending }</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )
                                                    }
                                                </div>

                                                {
                                                    agentPerformance &&
                                                    <>
                                                        <div className='grid md:grid-cols-5 gap-4'>
                                                            <div className='md:col-span-2 flex flex-col rounded-[10px] bg-white shadow-md p-4'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs md:mb-4 mb-2'>Annual Trip Target in {agentPerformance?.tripAchievement.year}</p>

                                                                <div className='md:mb-4 mb-2'>
                                                                    <p className='text-xs font-medium text-gray-two inline-block'>Sales Commission:</p>
                                                                    {
                                                                        agentPerformance?.tripAchievement?.label?.map((item, idx) => (
                                                                            item === 'Sales Commission' ?
                                                                            <span key={ 'sales_commission_'+idx } className='text-sm text-gray-one font-semibold ml-1'>
                                                                                RM { agentPerformance?.tripAchievement?.data[idx].toLocaleString() }
                                                                            </span> : null
                                                                        ))
                                                                    }
                                                                </div>

                                                                <div className='flex-1 flex flex-col-reverse justify-between md:gap-0 gap-1.5'>
                                                                    {
                                                                        agentPerformance?.tripAchievement?.label?.map((item, idx) => (
                                                                            item !== 'Sales Commission' ? <ProgressBar key={ 'progress_'+idx } sales={ agentPerformance?.tripAchievement } index={idx} /> : null
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className='md:col-span-3 rounded-[10px] bg-white shadow-md p-4 md:pl-2 overflow-hidden'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs mb-4 md:ml-2'>Annual Trip Target by Monthly</p>

                                                                <div className='overflow-auto'>
                                                                    <div className='w-[930px] md:w-auto'>
                                                                        <MultiaxisLineChart chartData={ agentPerformance?.tripAchievementProgressing } monthly={ true } title='Sales Commission (RM))' ratio='4' bp='0.6' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='grid md:grid-cols-3 gap-4'>
                                                            <div className='rounded-[10px] bg-white shadow-md p-4 md:pl-2 overflow-hidden'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs mb-4 md:ml-2'>Recruitment by Yearly</p>

                                                                <div className='overflow-auto'>
                                                                    <div className='w-[450px] md:w-auto'>
                                                                        <VerticalBarChart chartData={ agentPerformance?.recruitment } color='#6366f1' title='Total Recruitment' />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='rounded-[10px] bg-white shadow-md p-4 md:pl-2 overflow-hidden'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs mb-4 md:ml-2'>Project Sales by Yearly</p>

                                                                <div className='overflow-auto'>
                                                                    <div className='w-[450px] md:w-auto'>
                                                                        <VerticalBarChart chartData={ agentPerformance?.project } color='#a5b3fc' title='Project Sales (RM)' />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='rounded-[10px] bg-white shadow-md p-4 md:pl-2 overflow-hidden'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs mb-4 md:ml-2'>Sales Commission by Yearly</p>

                                                                <div className='overflow-auto'>
                                                                    <div className='w-[450px] md:w-auto'>
                                                                        <VerticalBarChart chartData={ agentPerformance?.commission?.yearly } color='#a855f7' title='Sales Commission (RM))' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='grid grid-cols-1 gap-4'>
                                                            <div className='rounded-[10px] bg-white shadow-md p-4 md:pl-2 overflow-hidden'>
                                                                <p className='font-semibold text-gray-two md:text-sm text-xs mb-4 md:ml-2'>Sales Commission by Monthly</p>

                                                                <div className='overflow-auto'>
                                                                    <div className='w-[1450px] md:w-auto'>
                                                                        <VerticalBarChart chartData={ agentPerformance?.commission?.monthly } monthly={ true } color='#f97315' title='Sales Commission (RM)' ratio='5' bp='0.6' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default PerformanceModal